import EmptyState from "../UI/EmptyState";
import ResponsePhrasesRow from "./ResponsePhrasesRow";

const ResponsePhrasesTable = ({ frases }) => {
  if (!frases.length)
    return <EmptyState title="No hay frases de respuesta para este plantel" />;

  return (
    <div className="table-responsive">
      <table className="table bordered-table mb-0">
        <thead>
          <tr>
            <th>Frase</th>
            <th>Valor</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          {frases.map((f) => (
            <ResponsePhrasesRow key={f.id} phrase={f} />
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default ResponsePhrasesTable;
